// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebarAdmin_sidebar__HwVYu","center":"sidebarAdmin_center__sLXmJ","icon":"sidebarAdmin_icon__B90ff","title":"sidebarAdmin_title__qxD4H"};